import { Form, Head } from "@inertiajs/react"

import InputError from "@/components/input-error"
import TextLink from "@/components/text-link"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AuthLayout from "@/layouts/auth-layout"
import { newIdentityPasswordResetPath, signInPath, signUpPath } from "@/routes"
import { t } from "@/lib/i18n"

export default function Login() {
  return (
    <AuthLayout
      title={t("auth.login.title")}
      description={t("auth.login.description")}
    >
      <Head title={t("auth.sign_in")} />
      <Form
        method="post"
        action={signInPath()}
        resetOnSuccess={["password"]}
        className="flex flex-col gap-6"
      >
        {({ processing, errors }) => (
          <>
            <div className="grid gap-6">
              <div className="grid gap-2">
                <Label htmlFor="email">{t("auth.login.email")}</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoFocus
                  tabIndex={1}
                  autoComplete="email"
                  placeholder={t("auth.login.email_placeholder")}
                />
                <InputError messages={errors.email} />
              </div>

              <div className="grid gap-2">
                <div className="flex items-center">
                  <Label htmlFor="password">{t("auth.login.password")}</Label>
                  <TextLink
                    href={newIdentityPasswordResetPath()}
                    className="ml-auto text-sm"
                    tabIndex={5}
                  >
                    {t("auth.forgot_password")}
                  </TextLink>
                </div>
                <Input
                  id="password"
                  type="password"
                  name="password"
                  required
                  tabIndex={2}
                  autoComplete="current-password"
                  placeholder={t("auth.login.password_placeholder")}
                />
                <InputError messages={errors.password} />
              </div>

              <Button
                type="submit"
                className="mt-4 w-full"
                tabIndex={4}
                disabled={processing}
              >
                {processing && <Spinner />}
                {t("auth.login.button")}
              </Button>
            </div>

            <div className="text-muted-foreground text-center text-sm">
{t("auth.no_account")}{" "}
              <TextLink href={signUpPath()} tabIndex={5}>
                {t("auth.sign_up")}
              </TextLink>
            </div>
          </>
        )}
      </Form>
    </AuthLayout>
  )
}
